import 'whatwg-fetch';
import 'idempotent-babel-polyfill';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

let listLoads = [];

async function api(queryPath)
{
  listLoads.forEach((control) => {
    control.abort();
  })
  listLoads = [];
  const controller = new AbortController();
  listLoads.push(controller);
  const signal = controller.signal;
  try {
    const response = await fetch(queryPath);
    console.debug(response);
    return await response.json();
  } catch(e) {
    return null;
  }
}

export default api;
